import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from "@angular/router";
import {SqlService} from "../../Database/sql.service";
import {ModalDismissReasons, NgbModal} from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-edit-providers',
  templateUrl: './edit-providers.component.html',
  styleUrls: ['./edit-providers.component.css']
})
export class EditProvidersComponent implements OnInit {

  constructor(private dbService: SqlService,private route: ActivatedRoute,  private router: Router,private modalService: NgbModal) { }

  oldProviderName="";
  ProviderName= "";
  DirectBoxSize = 10;
  DirectBatchSize = 1;
  InDirectBoxSize = 10;
  InDirectBatchSize = 1;

  ngOnInit(): void {

    this.route.paramMap.subscribe(params => {
      this.getData(params.get('ID'));
    });

  }

  async getData(ID:any){
   


    await(this.dbService.GetSpecificProvider(ID).subscribe((ret:any) => {
      if(ret != "false"){
      
        let a = (ret as string).split(',');
        this.ProviderName = a[0];
        this.oldProviderName = a[0];
        this.DirectBoxSize = Number(a[1]);
        this.DirectBatchSize = Number(a[2]);
        this.InDirectBoxSize = Number(a[3]);
        this.InDirectBatchSize = Number(a[4]);

      }else{
        this.PopupTitle = "Something went wrong"
        this.DisplayErrormessage = "Something went wrong, please try again. If this continues please contact the I.T Department";
        let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
        element.click();
      }
    }));
  }


  async Delete(){
    await(this.dbService.DeleteProvider(this.ProviderName).subscribe((ret:any) => {
      if(!(String(ret).includes("Error"))){
        this.PopupTitle = "Success"
        this.DisplayErrormessage = "The Provider has been deleted";
        let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
        element.click();
        this.Back();
      }else{
         if((String(ret).includes("Duplicate entry")) || (String(ret).includes("duplicate key"))){
          this.PopupTitle = "Invalid Details"
          this.DisplayErrormessage = "This Provider already exists";
          let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
          element.click();
        }else{
          this.PopupTitle = "Something went wrong"
          this.DisplayErrormessage = "Something went wrong, please try again. If this continues please contact the I.T Department";
          let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
          element.click();
        }

      }
    }));
  }

  async Save(){

    if (this.DirectBoxSize > 300 || this.DirectBatchSize > 150 || this.InDirectBoxSize > 300 || this.InDirectBatchSize > 150) {
      this.PopupTitle = "Invalid Details"
      this.DisplayErrormessage = "Box size may not exceed 300";
      let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
      element.click();
    }else{
      await(this.dbService.EditProvider(this.oldProviderName, this.ProviderName, String(this.DirectBoxSize), String(this.DirectBatchSize), String(this.InDirectBoxSize), String(this.InDirectBatchSize)).subscribe((ret:any) => {
        if(!(String(ret).includes("Error"))){
          this.PopupTitle = "Success"
          this.DisplayErrormessage = "The Provider has been editted";
          let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
          element.click();
          this.Back();
        }else{
           if((String(ret).includes("Duplicate entry")) || (String(ret).includes("duplicate key"))){
            this.PopupTitle = "Invalid Details"
            this.DisplayErrormessage = "This Provider already exists";
            let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
            element.click();
          }else{
            this.PopupTitle = "Something went wrong"
            this.DisplayErrormessage = "Something went wrong, please try again. If this continues please contact the I.T Department";
            let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
            element.click();
          }

        }
      }));
    }
  }

  Reset(){
    this.ProviderName= "";
    this.DirectBoxSize = 10;
    this.DirectBatchSize = 1;
    this.InDirectBoxSize = 10;
    this.InDirectBatchSize = 1;
  }

  Back(){
    this.router.navigate(['ViewProviders']); 
  }



  closeResult = '';
  DisplayErrormessage = "";
  PopupTitle = "";
  open(content: any) {
    console.log("HI");
    this.modalService.open(content,
   {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = 
         `Dismissed ${this.getDismissReason(reason)}`;
      //let element: HTMLButtonElement = document.getElementById('ErrorButton') as HTMLButtonElement;
      //element.click();
    });
  }
  
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}
